const videos = document.querySelectorAll(".video-play");

if (videos) {
  videos.forEach((video) => {
    video.addEventListener("click", () => {
      const targetVideo = document.getElementById(video.dataset.video);
      targetVideo.play();
      targetVideo.controls = true;
      video.style.display = "none";
      targetVideo?.classList.add("is-playing");
    });
  });
}
